import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { DialogData } from "../../types";
import { _ } from "../../utils/helpers";
import { booking, DEFAULT_DIALOG_HANDLE, ROUTES, translator } from "../../utils/symbols";

export function RequiredProductDialog({ dialogData }: { dialogData: DialogData }) {
    const { state: { dialogHandles }, actions: { navigate } } = useApp()
    if (dialogData.dialog !== "required-product") return null
    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE
    return (
        <section
            className={`df fd-c jcfs aic r3 section p-r py-10 px-10 `}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <Icon icon='info' style={{ scale: '1.7' }} />
            <p id="dialog-description" className="text s20-400 mb-8 mt-9 center">{translator.extractTranslationFromString(dialogData.product.requiredText)}</p>
            <div className="df aic jcsb w-100 fd-c dialog-error-buttons">
                <button
                    className="button px-10 py-7 r3 text  center s20-500 w-100 b-0 contact-us df aic jcc"
                    onClick={() => {
                        for (let i = 0; i < dialogData.toAdd; i++) {
                            booking.handleProduct("add", dialogData.product)
                        }
                        booking.setBookingStep("personal-details").render()
                        dialogHandle.closeDialog()
                        navigate(ROUTES.PERSONAL_DETAILS)
                    }}
                >
                    {_("0ge_add____")} x{dialogData.toAdd} {dialogData.product?.name}
                </button>
                <button
                    className="button b-0 p-2 p-a zi-6 close df aic jcc"
                    onClick={() => dialogHandle.closeDialog()}
                    aria-label={_('0ar_close__')}
                >
                    <Icon icon="close" aria-hidden />
                </button>
            </div>
        </section>
    )
}